<template>
    <div>
        <top-bar-secondary>
            <template v-slot:module-action-left>
                <!------- Dashboard ------->
                <b-navbar-nav v-if="profile.currentView === constant.DASHBOARD">
                    <b-nav-item
                        key="NEWITEM"
                        to="/inventory/item-new"
                        v-if="_hasAccess('inventory.item.create')"
                    >
                        <i class="cus-add"></i>New Item
                    </b-nav-item>
                    <b-nav-item
                        key="BULKUPDATE"
                        @click="bulkUpdate"
                        v-if="_hasAccess('inventory.bulk.update')"
                    >
                        <i class="cus-page-white-lightning"></i>Bulk Update
                    </b-nav-item>
                </b-navbar-nav>

                <!------- New Item ------->
                <b-navbar-nav
                    v-else-if="
                        profile.currentView === constant.NEW && profile.isSaving
                    "
                >
                    <b-nav-item> Saving...</b-nav-item>
                </b-navbar-nav>
                <b-navbar-nav
                    v-else-if="
                        profile.currentView === constant.NEW &&
                        !profile.isSaving
                    "
                >
                    <b-nav-item
                        @click.prevent="savingCheckForm(null, true)"
                        key="SAVEDONE"
                    >
                        <i class="cus-disk"></i>Save + Done
                    </b-nav-item>
                    <b-nav-item
                        @click.prevent="savingCheckForm(null, true, true)"
                        key="SAVENEW"
                    >
                        <i class="cus-disk-add"></i>Save + New
                    </b-nav-item>
                    <b-nav-item
                        @click="() => redirectToDashoard(false)"
                        key="CANCEL"
                    >
                        <i class="cus-cancel"></i>Cancel
                    </b-nav-item>
                </b-navbar-nav>

                <!------- ITEM (View) ------->
                <b-navbar-nav
                    v-if="
                        profile.currentView === constant.PROFILE &&
                        profile.mode === constant.VIEW
                    "
                >
                    <b-nav-item
                        key="EDITITEM"
                        v-if="
                            _hasAccess('inventory.item.update') && itemDetails
                        "
                        @click="toggleProfileMode(constant.EDIT)"
                    >
                        <i class="cus-page-white-edit"></i>Edit Item
                    </b-nav-item>
                    <b-nav-item
                        key="DELETEITEM"
                        @click="confirmDelete()"
                        :disabled="
                            itemDetails && itemDetails.cubex_last_sync != ''
                        "
                        v-b-tooltip.hover
                        :title="
                            itemDetails && itemDetails.cubex_last_sync != ''
                                ? 'You must deactivate in MyCubex if you wish to delete this item'
                                : ''
                        "
                        v-if="
                            _hasAccess('inventory.item.delete') &&
                            itemDetails &&
                            itemDetails.is_deleteable
                        "
                    >
                        <i class="cus-delete"></i>Delete Item
                    </b-nav-item>
                    <b-nav-item
                        @click="mergeItem"
                        v-if="isMergeable"
                        key="MERGEITEM"
                    >
                        <i class="cus-arrow-refresh"></i>Merge Item
                    </b-nav-item>
                    <b-nav-item
                        v-else-if="isGreyOutMergeButton"
                        v-b-tooltip.hover.bottom
                        title="Inventory items with Uses cannot be merged. If you wish to merge this item, please remove the Uses first."
                        disabled
                    >
                        <i class="cus-arrow-refresh disabled-icon"></i
                        ><span class="text-muted">Merge Item</span>
                    </b-nav-item>
                </b-navbar-nav>

                <!------- ITEM (Edit) ------->
                <b-navbar-nav
                    v-else-if="
                        profile.currentView === constant.PROFILE &&
                        profile.mode === constant.EDIT &&
                        profile.isSaving
                    "
                >
                    <b-nav-item> Saving...</b-nav-item>
                </b-navbar-nav>
                <b-navbar-nav
                    v-else-if="
                        profile.currentView === constant.PROFILE &&
                        profile.mode === constant.EDIT &&
                        profile.isSaving === false
                    "
                >
                    <b-nav-item @click="savingCheckForm" key="EDITSAVEDONE">
                        <i class="cus-disk"></i>Save + Done
                    </b-nav-item>
                    <b-nav-item
                        @click="() => resetProfileState(false)"
                        key="EDITCANCEL"
                    >
                        <i class="cus-cancel"></i>Cancel
                    </b-nav-item>
                </b-navbar-nav>
            </template>
            <template v-slot:module-action-right>
                <b-navbar-nav v-if="!isEnhancedLayout" class="ml-auto">
                    <b-nav-form
                        @click="$refs['select-item'].focus()"
                        @contextmenu="rightClickHandler"
                        class="ml-auto"
                    >
                        <vet-select-item
                            ref="select-item"
                            :key="'search' + searchItemKey"
                            :focus-onload="isItemDashboard"
                            class="mr-sm-2 w-100 search nav-search show-actions"
                        />
                    </b-nav-form>
                </b-navbar-nav>
            </template>
        </top-bar-secondary>

        <content-wrapper>
            <router-view
                ref="routerView"
                :profileMode="profile.mode"
                :itemDetails="itemDetails"
                @saved="saved"
                @redirect-to-dashboard="redirectToDashoard"
                @set-item-details="setItemDetails"
            ></router-view>
        </content-wrapper>

        <!-- Inventory Dashboard -->
        <modal-bulk-update
            ref="modalBulkUpdate"
            @onsuccess="onSuccessBulkUpdate"
            @show-warning-modal="savingCheckDueBulk"
        />

        <!-- Inventory Item Profile -->
        <modal-delete
            ref="modalDeleteItem"
            v-if="itemId"
            @onsuccess="redirectToDashoard"
        />
        <modal-merge-item ref="modalMergeItem" @onsuccess="onSuccessMerged" />

        <modal-confirm-update-uses
            ref="modalConfirmUpdateUses"
            v-if="itemId"
            :itemId="itemId"
            :usesCount="usesCount"
            @proceed="savingCheckDue"
            @cancel="cancelSaved"
        />

        <modal-confirm-update-due
            ref="modalConfirmUpdateDue"
            @proceed="proceedSaveEditItem"
            @cancel="cancelSaved"
        />
        <modal-confirm-update-type
            ref="modalConfirmUpdateType"
            @proceed="savingCheckPrice"
            @cancel="cancelSaved"
        />
    </div>
</template>

<script>
import unsavePrompt from "@/mixins/unsave-prompt.js";
import VetSelectItem from "@/module/commons/vet-select-item";
import ModalMergeItem from "@/components/item/modal-merge";
import ModalBulkUpdate from "@/components/inventory-bulk-update/bulk-update";
import ModalDelete from "@/components/commons/modal-delete-inventory-item";
import modalConfirmUpdateUses from "@/components/item/modal-confirm-update-uses";
import modalConfirmUpdateDue from "@/components/item/modal-confirm-update-due";
import modalConfirmUpdateType from "@/components/item/modal-confirm-update-type";
import TopBarSecondary from "@/module/layout/top-bar-secondary.vue";
import ContentWrapper from "@/module/layout/content-wrapper.vue";

const DASHBOARD = "inventory_dashboard"; // same as defined in router.js
const PROFILE = "item";
const NEW = "item_new";
const VIEW = "VIEW";
const EDIT = "EDIT";
const STATUS_ACTIVE = 1;

/**
 * @name ItemIndex
 * Apply key to the b-nav-item with @click to prevent the button run click event when changing page
 */
export default {
    mixins: [unsavePrompt],
    components: {
        VetSelectItem,
        ModalBulkUpdate,
        ModalMergeItem,
        ModalDelete,
        modalConfirmUpdateUses,
        modalConfirmUpdateDue,
        modalConfirmUpdateType,
        TopBarSecondary,
        ContentWrapper
    },
    props: {},
    data() {
        return {
            searchItemKey: 0,
            constant: {
                DASHBOARD,
                NEW,
                PROFILE,
                VIEW,
                EDIT
            },
            profile: {
                currentView: "",
                mode: VIEW,
                isSaving: false
            },
            itemDetails: null,
            searchItem: null,
            usesCount: 0,
            isUpdateUses: false,
            isForBulk: false
        };
    },
    computed: {
        isMergeable() {
            let theUsesCount = this.$store.getters["inventory/usesCount"];
            return this._hasAccess("inventory.item.merge") &&
                this.itemDetails &&
                this.itemDetails.cubex_last_sync == ""
                ? this.itemDetails.status == STATUS_ACTIVE &&
                      !(
                          _.isEmpty(this.itemDetails.parent_item_id) &&
                          theUsesCount > 0
                      )
                : false;
        },
        isGreyOutMergeButton() {
            return this._hasAccess("inventory.item.merge") &&
                this.itemDetails &&
                this.itemDetails.cubex_last_sync == ""
                ? this.itemDetails.status == STATUS_ACTIVE
                : false;
        },
        itemId() {
            return this.itemDetails ? this.itemDetails.id : null;
        },
        isItemDashboard() {
            return this.$route.name == "inventory_dashboard";
        },
        form_dirty() {
            return this.$store.getters["inventory/isDirty"];
        },
        isPriceEdited() {
            return this.$store.getters["inventory/isPriceEdited"];
        },
        isDueChangeToNone() {
            return this.$store.getters["inventory/isDueChangeToNone"];
        },
        isEnhancedLayout() {
            return this.$store.state.isEnhancedLayout;
        }
    },
    beforeMount() {
        this._getSetting().then(() => {
            if (!this._hasAccess("inventory.access")) {
                this._redirectDefaultPage();
                this.$destroy();
            }
        });
    },
    watch: {
        async $route(to) {
            this.toggleView(to.name);
            await this.$nextTick();
            this.resetProfileState();
        },
        "$route.name"() {
            this.searchItemKey++;
        }
    },
    mounted() {
        const currentRoute = this.$router.history.current.name;
        this.toggleView(currentRoute);
        this.$root.$on("update-item-details", params => {
            this.setItemDetails(params);
        });
    },
    destroyed() {
        this.$root.$off("update-item-details");
    },
    methods: {
        onSuccessMerged(targetEncodedId) {
            this.$router.replace(`/inventory/item/${targetEncodedId}`);
        },
        onSuccessBulkUpdate() {
            this.$refs.routerView.onSuccessBulkUpdate();
        },
        goToAppPage() {
            window.open(
                `${process.env.CI_APPS}inventory/item/view/${this.itemDetails.encoded_id}`,
                "_blank"
            );
        },
        mergeItem() {
            this.$refs.modalMergeItem.open({
                itemId: this.itemDetails.id,
                encodedId: this.itemDetails.encoded_id,
                itemName: this.itemDetails.name
            });
        },
        bulkUpdate() {
            this.$refs.modalBulkUpdate.open({});
        },
        redirectToDashoard() {
            this.$store.commit("inventory/setDirty", false);
            this.$router.replace("/inventory/dashboard");
        },
        setItemDetails(details) {
            this.itemDetails = details;
        },
        toggleView(routeName) {
            this.profile.currentView = routeName;
        },
        toggleProfileMode(value) {
            this.profile.mode = value;
            if (value == EDIT) {
                this.$refs.routerView.resetTab();
            }
        },
        /////////////////
        // FLOW SAVING //
        /////////////////
        /**
         * @method savingCheckForm
         * @description Flow to save item edit
         * savingCheckForm(index.vue) -> checkFormValid(item.vue) -> isValid(item/create-update.vue) : Boolean
         * savingCheckPrice(index.vue) -> proceed/open modal update base price
         * savingCheckDue(index.vue) -> open modal warning update due
         * proceedSaveEditItem
         */
        async savingCheckForm(event, isNewItem = false, addNew = false) {
            this.profile.isSaving = true;
            const isFormValid = await this.$refs.routerView.savingCheckFormValid();
            if (!isFormValid) {
                this.cancelSaved();
                return;
            }

            if (isNewItem) {
                this.savingNew(addNew);
            } else {
                if (this.$refs.routerView.isTypeChangedFromFee()) {
                    this.$refs["modalConfirmUpdateType"].open();
                    this.profile.isSaving = false;
                } else {
                    this.savingCheckPrice();
                }
            }
        },
        ////////////////////////
        // FLOW SAVING - EDIT //
        ////////////////////////
        /**
         * @method savingCheckPrice
         * @description check whether to prompt update uses if make a change to quantity and cost type, else just proceed
         */
        savingCheckPrice() {
            this.profile.isSaving = true;
            if (this.isPriceEdited) {
                this.$store
                    .dispatch("inventory/getUsesCount", this.itemDetails.id)
                    .then(usesCount => {
                        this.hasCheckPrice = true;
                        this.usesCount = usesCount;
                        if (usesCount > 0) {
                            this.$refs["modalConfirmUpdateUses"].open();
                        } else {
                            this.savingCheckDue(false);
                        }
                    });
                return;
            }
            this.savingCheckDue(false);
        },
        /**
         * @method savingCheckDue
         * @description check whether to prompt update warning message when update item due to none
         */
        savingCheckDue(isUpdateUses) {
            this.isUpdateUses = isUpdateUses;
            if (this.isDueChangeToNone) {
                this.$refs["modalConfirmUpdateDue"].open();
                return;
            }
            this.proceedSaveEditItem();
        },
        /**
         * @method savingCheckDueBulk
         * @description check whether to prompt update warning message when bulk update item due to none
         */
        savingCheckDueBulk() {
            this.isForBulk = true;
            this.$refs["modalConfirmUpdateDue"].open();
        },
        /**
         * @method proceedSaveEditItem
         * @description Before proceed saving, the flow must check price tier and due changes.
         */
        proceedSaveEditItem() {
            if (this.isForBulk) {
                this.$refs["modalBulkUpdate"].proceed();
            } else {
                this.$refs.routerView.savingEditItem(this.isUpdateUses);
            }
        },
        ///////////////////////
        // FLOW SAVING - NEW //
        ///////////////////////
        /**
         * @method savingNew
         * @description Before proceed saving, the flow must check price tier and due changes.
         */
        savingNew(addNew = false) {
            this.$refs.routerView.savingNewItem(addNew);
        },
        /**
         * @method cancelSaved
         * @description Cancel saving and return to edit mode form or bulk update modal
         */
        cancelSaved() {
            if (this.isForBulk) {
                this.isForBulk = false;
            } else {
                this.isUpdateUses = false;
                this.profile.isSaving = false;
            }
        },
        /**
         * @method saved
         * @description Form has been saved
         */
        saved(result = {}) {
            this.profile.isSaving = false;
            if (result.success) {
                this.profile.mode = VIEW;
            }
        },
        /**
         * @method resetProfileState
         * @description Reset profile mode used when change item profile and cancel edit
         */
        resetProfileState(clearDetails = true) {
            if (clearDetails) {
                this.itemDetails = null;
            }
            this.profile.mode = VIEW;
            this.$store.commit("inventory/setDirty", false);
            if (this.profile.currentView == this.constant.PROFILE) {
                this.$refs.routerView.resetTab();
            }
        },
        confirmDelete() {
            this.$refs.modalDeleteItem.open(this.itemDetails.id);
        },
        rightClickHandler(e) {
            if (e.which === 3) {
                this.$refs["select-item"].focus();
            }
        }
    }
};
</script>
